<template>
  <div class="clientLabel">
    <el-card class="box-card label" v-if="companyLabel.length">
      <h3>企业标签</h3>
      <div
        v-for="(item, index) in companyLabel"
        :key="index"
        class="labelBox"
        style="margin:20px 0 0"
      >
        <div class="lt">
          <h4>{{ item.title }}</h4>
          <span>共{{ item.childrenData.length }}个标签</span>
        </div>
        <div class="ct">
          <el-button
            size="mini"
            :type="tiem.is_top == 2 ? 'primary' : ''"
            style="margin:10px 10px 0 0"
            v-for="tiem in item.childrenData"
            :key="tiem.id"
            >{{ tiem.title }}</el-button
          >
        </div>
      </div>
      <h3 style="margin:20px 0" v-show="personLabel.length">个人标签</h3>
      <div class="labelBox" v-show="personLabel.length">
        <el-button
          size="mini"
          :type="time.is_top == 2 ? 'primary' : ''"
          style="margin:10px 10px 0 0"
          v-for="time in personLabel"
          :key="time.id"
          >{{ time.title }}</el-button
        >
      </div>
    </el-card>
    <el-empty v-else description="暂无标签组"></el-empty>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      Type: Number,
      default: 0,
    },
    index: {
      Type: String,
      default: '',
    },
  },
  data() {
    return {
      companyLabel: [], //企业标签
      personLabel: [], //个人标签
    }
  },
  watch: {
    index(val) {
      this.companyLabel = []
      this.personLabel = []
      if (val == 1) this.getLabelList()
    },
  },
  methods: {
    async getLabelList() {
      const res = await this.$api.customerLabel({
        id: this.id,
      })
      this.companyLabel = res.companyLabel
      this.personLabel = res.personLabel
    },
  },
}
</script>

<style lang="scss">
.clientLabel {
  .box-card.label {
    height: calc(100vh - 155px);
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e4e7ed;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
    }
  }

  .labelBox {
    height: auto;
    overflow: hidden;
    border-top: 1px solid #dcdfe6;

    &:first-child {
      border-top: none;
    }

    padding: 15px 0 0;

    .lt {
      display: flex;
      width: 200px;
      margin: 10px 30px 0 0;
      h4 {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .rt {
      margin-top: 2px;
    }
    .ct {
      p {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
